<app-third-party [vendorName]="vendorName"
                 [name]="name"
                 [disableAuto]="true"
                 btnText="Request Adobe Express License"
                 btnClasses="bg-dark text-white px-5 py-3 mb-5 text-uppercase"
>
</app-third-party>
